import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/eatWellContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-charcoal-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-57" data-mp="1bmlmp7radxkh">
      <div className="mx-auto max-w-2xl px-5" data-id="element-58" data-mp="1gjvj57d3f9ht">
        <h2 id="faq-title" className="text-center font-display text-2xl font-semibold uppercase leading-tight text-ivory-50 sm:text-4xl" data-id="element-59" data-mp="248o98n71an4i">
          What we get asked most
        </h2>

        <ul className="mt-9 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-60" data-mp="1uibpgx71mxzf">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-61" data-mp="2n7ipk0m5bvms" data-mpi={i}>
                <h3 data-id="element-62" data-mp="2n6h7hc6pq8vk">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-4 text-left" data-id="element-63" data-mp="2n67inrxem7rg">
                    <span className="font-display text-lg leading-snug text-ivory-50 sm:text-xl" data-id="element-64" data-mp="1eln64hq9g4lp">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-champagne transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-65" data-mp="19sajgd5567vl" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-66" data-mp="1sm67j6080cew">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-67" data-mp="36zs9pagphzz">
                      <p className="pb-5 text-[14px] leading-relaxed text-body" data-id="element-68" data-mp="2867ufpxi3heh">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}